import React from "react";
import "./Project.css";
const Project = () => {
  return (
    <div>
      <div className=" mt-3 pb-5">
        <div className="banner-content">
          <h1>Project</h1>
        </div>
      </div>
    </div>
  );
};

export default Project;
